@use "../../../styles/variables" as *;
.client-filters {
  .filter-drawer-button {
    display: none;
    .filter-icon {
      margin-right: 4px;
    }
  }
  @media screen and (width < $breakpoint-lg) {
    .filter-drawer-button {
      display: block;
    }
    .fiter-container {
      display: none;
    }
  }
}
